const orderData = {
    perHeadCost: 9,
    tax: 10,
    shippingCost: 20
}

export default orderData;